import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M0 2.5v13h18v-13H0zm8.904 5.683l.642.204c.705.218 2.163.675 2.163 2.276 0 1.151-.765 1.981-1.959 2.241V14h-1.5v-1.065c-1.206-.21-1.943-.984-1.959-2.133l1.5-.021c.003.196.01.718 1.146.718.383 0 1.273-.081 1.273-.835 0-.368-.168-.552-1.114-.846l-.006-.002-.636-.203c-.699-.217-2.163-.672-2.163-2.276 0-1.151.765-1.981 1.959-2.241V4h1.5v1.065c1.206.21 1.943.984 1.959 2.133l-1.5.021c-.003-.196-.01-.718-1.146-.718-.383 0-1.273.081-1.273.835.001.369.169.553 1.114.847z" />
  </svg>
);

export default SvgComponent;
